import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const LongShortChart = ({ labels, seriesData, name }) => {
  // Sample data for testing
  const dummyData = {
    number_of_long_trade: [24, 30, 22, -15, -10], // Representing 'Win' values for each day
    days: ["Mon", "Tue", "Wed", "Thu", "Fri"], // Sample categories
  };

  const [Series, setSeries] = useState([
    {
      name: name,
      type: "bar",
      data: [],
    },
  ]);

  const Options = {
    colors: ["#0D56EB"],
    fill: {
      colors: ["#0D56EB"],
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: ["rgba(23, 171, 252, 0.00)"],
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        columnWidth: "30%",
        distributed: false,
      },
    },
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "bar",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1, // Reduced stroke width
    },
    grid: {
      borderColor: "#393939",
      strokeDashArray: 0,
    },
    xaxis: {
      categories: labels,
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        rotate: -45,
        style: {
          colors: "#ffffff",
          fontSize: "14px",
          fontWeight: 700,
        },
      },
    },
    yaxis: [
      {
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: true,
    },
  };

  useEffect(() => {
    setSeries([
      {
        name: name,
        type: "bar",
        data: seriesData,
      },
    ]);
  }, [seriesData]);

  return (
    <div id="chart" className="long_short_barChart">
      <ReactApexChart options={Options} series={Series} height={"100%"} />
    </div>
  );
};

export default LongShortChart;

// const LongShortChart = ({ data }) => {
//   const [Series, setSeries] = useState([
//     {
//       type: "bar",
//       data: [],
//     },
//   ]);
//   const Options = {
//     colors: ["#04D9FF"],
//     fill: {
//       colors: [
//         function ({ value }) {
//           console.log(value, "VALUEEEE");
//           if (value < 0) {
//             return "#FD504F";
//           } else return "#04D9FF";
//         },
//       ],
//       type: "gradient",
//       gradient: {
//         type: "vertical",
//         shadeIntensity: 0,
//         gradientToColors: undefined,
//         opacityFrom: 0.7,
//         opacityTo: 0.2,
//         stops: [0, 90, 100],
//       },
//     },
//     legend: {
//       fontSize: "14px",
//       fontWeight: 700,
//       labels: {
//         colors: "white",
//       },
//       markers: {
//         width: 15,
//         height: 15,
//       },
//     },

//     plotOptions: {
//       bar: {
//         borderRadius: 10,
//         columnWidth: "70%",
//         distributed: true,
//       },
//     },

//     chart: {
//       fontFamily: "Outfit, sans-serif",
//       toolbar: {
//         show: false,
//       },
//       height: 350,
//       type: "bar",
//       zoom: {
//         enabled: false,
//       },
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     stroke: {
//       curve: "smooth",
//       width: 4,
//     },
//     grid: {
//       borderColor: "#415672",
//       strokeDashArray: 8,
//     },
//     xaxis: {
//       seriesName: "No. of trades",
//       //   title: {
//       //     text: "No. of trades",
//       //     style: {
//       //       fontSize: 14,
//       //       fontWeight: 700,
//       //       color: "#ffffff",
//       //     },
//       //   },
//       categories: ["Long", "Short"],
//       tooltip: {
//         enabled: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//       axisBorder: {
//         show: false,
//       },
//       labels: {
//         rotate: -45,
//         style: {
//           colors: "#ffffff",
//           fontSize: "14px",
//           fontWeight: 700,
//         },
//       },
//     },
//     yaxis: [
//       {
//         seriesName: "Balance",
//         // title: {
//         //   text: "Balance",
//         //   style: {
//         //     fontSize: 14,
//         //     fontWeight: 700,
//         //     color: "#ffffff",
//         //   },
//         // },
//         labels: {
//           style: {
//             colors: "#8B8E93",
//             fontSize: "12px",
//           },
//         },
//       },

//       // type: 'datetime',
//     ],
//     tooltip: {
//       enabled: true,
//     },
//   };

//   useEffect(() => {
//     if (data && data.number_of_long_trade) {
//       setSeries([
//         {
//           type: "bar",
//           data: [data.number_of_long_trade, data.number_of_Short_trade],
//         },
//       ]);
//     }
//   }, [data]);

//   return (
//     <div id="chart">
//       <ReactApexChart options={Options} series={Series} height={390} />
//     </div>
//   );
// };
// export default LongShortChart;
